export const signHTML = '<!-- HTML Generated by Creative Maker -->'
export const signStartComponents = '<!-- Start all components -->'
export const signEndComponents = '<!-- End all components -->'
